import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-new-to-bank-cmb.component.scss";
var FormItemNewToBankCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNewToBankCmb, _super);
    function FormItemNewToBankCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemNewToBankCmb.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.flexibleFuneralPlanCmbForm = this.element.querySelector("form");
        this.applyFormRadio = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.flexibleFuneralPlanCmbSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
        this.queryParams = new URLSearchParams(window.location.search);
        // this.doneBtn = this.element.querySelector(".done-btn");
        // this.doneBtn = this.element.querySelectorAll(".done-btn");
        this.doneBtn = this.element.querySelectorAll(".done-btn");
        this.closeButton = this.element.querySelectorAll(".done-btn");
        // Data Consnet
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemNewToBankCmb.prototype.bindEvents = function () {
        var _this = this;
        this.flexibleFuneralPlanCmbSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var formFields = _this.flexibleFuneralPlanCmbForm.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.flexibleFuneralPlanCmbForm.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.actionForm(_this.flexibleFuneralPlanCmbForm);
                }
            });
        });
        // this.doneBtn.addEventListener("click", (event) => {
        // 	this.resetForm();
        // });
        this.applyFormRadio.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var identificationField = _this.applyForm.querySelector("input[name=identification]");
                var identificationType = evt.value;
                _this.idType = identificationType;
                if (identificationType === "said") {
                    identificationField.classList.remove("form__input--identification--passport");
                    identificationField.classList.add("form__input--identification");
                    identificationField.placeholder = "Enter you South Africa ID number";
                    identificationField.type = "number";
                }
                else {
                    identificationField.classList.remove("form__input--identification");
                    identificationField.classList.add("form__input--identification--passport");
                    identificationField.placeholder = "Enter you Passport number";
                    identificationField.type = "text";
                }
            });
        });
        // this.doneBtn.addEventListener("click", (event) => {
        // 	this.resetForm();
        // });
        // this.doneBtn.forEach((item) => {
        // 	item.addEventListener("click", (event) => {
        // 		this.resetForm();
        // 		this.analyticsService.dtmFormAbandon();
        // 	});
        // });
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.closeButton.forEach(function (item) {
            item.addEventListener("click", function (event) {
                _this.closeModal();
            });
        });
    };
    FormItemNewToBankCmb.prototype.closeModal = function () {
        this.analyticsService.dtmFormAbandon();
        this.resetForm();
        // this.activeModal.classList.add('modal--close');
        // setTimeout(() => {
        // 	this.activeModal.classList.add('modal--closed');
        // }, 250);
    };
    FormItemNewToBankCmb.prototype.resetForm = function () {
        if (this.flexibleFuneralPlanCmbForm) {
            this.flexibleFuneralPlanCmbForm.reset();
            var formContainerFields = this.element.querySelector(".form__fields--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            formContainerThankyou.classList.remove("active");
            formContainerFields.classList.remove("hidden");
        }
    };
    //get Data statments
    FormItemNewToBankCmb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemNewToBankCmb.prototype.actionForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var product = form.querySelector("input[name=product-interest]");
        var firstname = form.querySelector("input[name=first-name]");
        var surname = form.querySelector("input[name=last-name]");
        var contactNumber = form.querySelector("input[name=phone-number]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var saId = form.querySelector("input[name=identification]");
        var qualification = form.querySelector("input[name=qualification-occupation]");
        var province = form.querySelector("select[name=province");
        var marketingConsent = form.querySelector("input[name=marketing-consent]");
        var futureEngamentContactConsent = form.querySelector("input[name=future-engament-contact-consent]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var queryParams = new URLSearchParams(window.location.search);
        var cId = queryParams.get("cid");
        console.log("Param ", queryParams);
        console.log("Param CID", cId);
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        // const url = '/services/SBIS_Handler_COZA.jsp';
        // const url = "/savepernewtobank";
        // const url = this.baseUrl + `/leadsutils/savepernewtobank`;
        var url = "/leadsutils/savepernewtobank";
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        var postData = {
            product: product.value,
            firstName: firstname.value,
            surname: surname.value,
            // saId: saId.value,
            saId: this.idType == "said" ? saId.value : "",
            passportNumber: this.idType == "passport" ? saId.value : "",
            idType: this.idType,
            qualification: qualification.value,
            contactNumber: contactNumber.value,
            emailAddress: emailAddress.value,
            province: province.value,
            // marketingConsent: marketingConsent.value,
            marketingConsent: marketingConsent
                ? marketingConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            // futureEngamentContactConsent: futureEngamentContactConsent.value,
            futureEngamentContactConsent: futureEngamentContactConsent
                ? futureEngamentContactConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            cid: cId,
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            dataSharingGroup: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharing3rdParty: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingBoarders: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data ||
                response.data.toString().includes("invalid")) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete("complete", response.code, false, "", emailAddress.value, contactNumber.value);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete("complete", response.status, false, "", emailAddress.value, contactNumber.value);
                }
                else {
                    analyticsService.dtmFormComplete("complete", "200");
                }
                thankYou.classList.add("active");
                error.classList.remove("active");
                error.classList.add("hidden");
                success.classList.remove("hidden");
                success.classList.add("active");
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemNewToBankCmb;
}(Base));
export { FormItemNewToBankCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-new-to-bank-cmb/form-item-new-to-bank-cmb.component.ts
// module id = 1023
// module chunks = 0